var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import { toast } from "react-toastify";
import { parse } from "../../../lib/qmreader";
import { emptyQmm } from "./emptyQmm";
import { greetingsQmm } from "./greetingsQmm";
var EDITOR_INDEXEDDB_NAME = "space-rangers-editor";
var INDEXEDDB_EDITOR_AUTOSAVE_STORE = "autosave";
var AUTOSAVE_SIZE = 500;
function writeQuest(db, quest, index) {
    return __awaiter(this, void 0, void 0, function () {
        var transaction, objectStore, higherKeysRemoveRequest, saveRequest, removingThreshold, olderKeysRemoveRequest_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    transaction = db.transaction([INDEXEDDB_EDITOR_AUTOSAVE_STORE], "readwrite");
                    objectStore = transaction.objectStore(INDEXEDDB_EDITOR_AUTOSAVE_STORE);
                    higherKeysRemoveRequest = objectStore.delete(IDBKeyRange.lowerBound(index));
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            higherKeysRemoveRequest.onsuccess = function () { return resolve(); };
                            higherKeysRemoveRequest.onerror = function () { var _a; return reject(new Error((_a = higherKeysRemoveRequest.error) === null || _a === void 0 ? void 0 : _a.message)); };
                        })];
                case 1:
                    _a.sent();
                    saveRequest = objectStore.put(quest, index);
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            saveRequest.onsuccess = function () { return resolve(); };
                            saveRequest.onerror = function () { var _a; return reject(new Error((_a = saveRequest.error) === null || _a === void 0 ? void 0 : _a.message)); };
                        })];
                case 2:
                    _a.sent();
                    removingThreshold = index - AUTOSAVE_SIZE;
                    if (!(removingThreshold > 0)) return [3 /*break*/, 4];
                    olderKeysRemoveRequest_1 = objectStore.delete(IDBKeyRange.upperBound(removingThreshold));
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            olderKeysRemoveRequest_1.onsuccess = function () { return resolve(); };
                            olderKeysRemoveRequest_1.onerror = function () { var _a; return reject(new Error((_a = olderKeysRemoveRequest_1.error) === null || _a === void 0 ? void 0 : _a.message)); };
                        })];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
function readLatestIndex(db) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var transaction = db.transaction([INDEXEDDB_EDITOR_AUTOSAVE_STORE], "readonly");
                    var objectStore = transaction.objectStore(INDEXEDDB_EDITOR_AUTOSAVE_STORE);
                    var openCursorRequest = objectStore.openKeyCursor(null, "prev");
                    openCursorRequest.onsuccess = function (event) {
                        if (openCursorRequest.result && typeof openCursorRequest.result.key === "number") {
                            resolve(openCursorRequest.result.key);
                        }
                        else {
                            resolve(null);
                        }
                    };
                    openCursorRequest.onerror = function (e) { var _a; return reject(new Error((_a = openCursorRequest.error) === null || _a === void 0 ? void 0 : _a.message)); };
                })];
        });
    });
}
function readQuest(db, index) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var transaction = db.transaction([INDEXEDDB_EDITOR_AUTOSAVE_STORE], "readonly");
                    var objectStore = transaction.objectStore(INDEXEDDB_EDITOR_AUTOSAVE_STORE);
                    var request = objectStore.get(index);
                    request.onsuccess = function () {
                        var result = request.result;
                        if (result) {
                            resolve(result);
                        }
                        else {
                            resolve(null);
                        }
                    };
                    request.onerror = function (e) { var _a; return reject(new Error((_a = request.error) === null || _a === void 0 ? void 0 : _a.message)); };
                })];
        });
    });
}
function initDatabase() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var idb = window.indexedDB.open(EDITOR_INDEXEDDB_NAME, 7);
                    console.info("idb opened");
                    idb.onerror = function (e) {
                        var _a;
                        reject(new Error((_a = idb.error) === null || _a === void 0 ? void 0 : _a.message));
                        // toast("IndexedDB error: " + idb.error?.message);
                    };
                    idb.onsuccess = function (e) { return resolve(idb.result); };
                    idb.onupgradeneeded = function (event) {
                        console.info("onupgradeneeded");
                        var db = idb.result;
                        console.info("Old version=" + event.oldVersion);
                        if (event.oldVersion < 7) {
                            console.info("Creating " + INDEXEDDB_EDITOR_AUTOSAVE_STORE + " store");
                            db.createObjectStore(INDEXEDDB_EDITOR_AUTOSAVE_STORE, {
                                // keyPath: false,
                                autoIncrement: false,
                            });
                        }
                    };
                })];
        });
    });
}
export function useIdb() {
    var _this = this;
    var _a = __read(React.useState(undefined), 2), db = _a[0], setDb = _a[1];
    var _b = __read(React.useState(), 2), broadcastChannel = _b[0], setBroadcastChannel = _b[1];
    React.useEffect(function () {
        // tslint:disable-next-line:strict-type-predicates
        if (typeof BroadcastChannel === "undefined") {
            return;
        }
        var bc = new BroadcastChannel("space-ranger-editor-questupdated");
        setBroadcastChannel(bc);
        return function () {
            bc.close();
        };
    }, []);
    var _c = __read(React.useState(null), 2), state = _c[0], setState = _c[1];
    var setFallbackEmptyState = React.useCallback(function () {
        var emptyQuest = parse(emptyQmm);
        setState({
            quest: emptyQuest,
            undoQuest: null,
            redoQuest: null,
            currentIndex: 1,
        });
    }, []);
    React.useEffect(function () {
        initDatabase()
            .then(function (freshDb) { return setDb(freshDb); })
            .catch(function (e) {
            setFallbackEmptyState();
            toast("Failed to init database: " + e.message);
        });
    }, [setFallbackEmptyState]);
    var saveQuest = React.useCallback(function (newQuest) {
        setState({
            currentIndex: state ? state.currentIndex + 1 : 1,
            undoQuest: state ? state.quest : null,
            redoQuest: null,
            quest: newQuest,
        });
        if (!db) {
            toast("No database to save quest");
            return;
        }
        if (!state) {
            toast("No previous state to save quest");
            return;
        }
        writeQuest(db, newQuest, state.currentIndex + 1)
            .then(function () {
            if (broadcastChannel) {
                broadcastChannel.postMessage("");
            }
            else {
                toast("No broadcast channel to send message");
            }
        })
            .catch(function (e) { return toast("Failed to save quest: " + e.message + "!"); });
    }, [db, state, broadcastChannel]);
    var startupLoad = React.useCallback(function () {
        console.info("Editor startup loading dbIsReady=" + db);
        if (!db) {
            return;
        }
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var latestIndex, greetingsQuest, quest, prevQuest;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, readLatestIndex(db)];
                    case 1:
                        latestIndex = _a.sent();
                        if (!latestIndex) {
                            greetingsQuest = parse(greetingsQmm);
                            setState({
                                quest: greetingsQuest,
                                undoQuest: null,
                                redoQuest: null,
                                currentIndex: 1,
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, readQuest(db, latestIndex)];
                    case 2:
                        quest = _a.sent();
                        return [4 /*yield*/, readQuest(db, latestIndex - 1)];
                    case 3:
                        prevQuest = _a.sent();
                        if (!quest) {
                            setFallbackEmptyState();
                            toast("Could not read saved quest at index " + latestIndex);
                            return [2 /*return*/];
                        }
                        setState({
                            quest: quest,
                            undoQuest: prevQuest,
                            redoQuest: null,
                            currentIndex: latestIndex,
                        });
                        return [2 /*return*/];
                }
            });
        }); })().catch(function (e) {
            setFallbackEmptyState();
            toast("Failed to read from database: " + e.message);
        });
    }, [db, setFallbackEmptyState]);
    React.useEffect(function () {
        startupLoad();
    }, [startupLoad]);
    React.useEffect(function () {
        if (!broadcastChannel) {
            return;
        }
        broadcastChannel.onmessage = function () {
            // console.info("broadcastChannel got message");
            startupLoad();
        };
        return function () {
            broadcastChannel.onmessage = null;
        };
    }, [startupLoad, broadcastChannel]);
    var undo = React.useMemo(function () {
        if (!db || !state || !state.undoQuest) {
            return null;
        }
        var undoQuest = state.undoQuest;
        return function () {
            setState({
                quest: undoQuest,
                undoQuest: null,
                redoQuest: state.quest,
                currentIndex: state.currentIndex - 1,
            });
            // Read one more quest to be able to undo
            readQuest(db, state.currentIndex - 2)
                .then(function (undoQuest) {
                setState(function (oldState) {
                    return oldState
                        ? __assign(__assign({}, oldState), { undoQuest: undoQuest }) : null;
                });
            })
                .catch(function (e) { return toast("Failed to read previous quest: " + e.message); });
        };
    }, [db, state]);
    // Quite a copy-paste from undo
    var redo = React.useMemo(function () {
        if (!db || !state || !state.redoQuest) {
            return null;
        }
        var redoQuest = state.redoQuest;
        return function () {
            setState({
                quest: redoQuest,
                undoQuest: state.quest,
                redoQuest: null,
                currentIndex: state.currentIndex + 1,
            });
            // Read one more quest to be able to redo
            readQuest(db, state.currentIndex + 2)
                .then(function (redoQuest) {
                setState(function (oldState) {
                    return oldState
                        ? __assign(__assign({}, oldState), { redoQuest: redoQuest }) : null;
                });
            })
                .catch(function (e) { return toast("Failed to read quest to next redo: " + e.message); });
        };
    }, [db, state]);
    return {
        quest: state === null || state === void 0 ? void 0 : state.quest,
        setQuest: saveQuest,
        undo: undo,
        redo: redo,
    };
}
//# sourceMappingURL=data:application/json;base64,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